import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../../store/hooks/StoreHooks';
import useCollapseFacade from '../../../../facade/collapse.Facade';
import Accordion from '../../../common/accordion';
import LABELS from '../../../../constants/labels/schematics.labels';
import useCalculationFacade from '../../../../facade/calculation/calculation.facade';
import { SRMiscellaneousModel } from '../../../../store/model/calculations/schematics';
import Checkbox from '../../../common/checkbox';
import TextShortInput from '../../../common/TextShortInput';

const Miscellaneous = () => {
    const { miscellaneousCollapse } = useAppSelector(
        (state) => state?.collapse
    );
    const { updateSchematicOtherData } = useCalculationFacade();
    const { updateMiscellaneousCollapse } = useCollapseFacade();
    const { tab1Input } = useAppSelector(state => state?.tubing);
    const { schematicData } = useAppSelector(state => state?.calculations);

    const handleCollapseChange = (key: boolean) => {
        updateMiscellaneousCollapse(key);
    };
    const [equipments, setEquipments] = useState<any[]>([]);

    useEffect(() => {
        const surfaceCable = equipments.find(equipment => equipment.equipmentName === 'Surface Cable length (ft)');
        if (surfaceCable) {
            surfaceCable.quantity = tab1Input?.hdnCable_SurfCabl || 0;
        } else {
            setEquipments([...equipments, {
                equipmentName: 'Surface Cable length (ft)',
                quantity: tab1Input?.hdnCable_SurfCabl || 0,
                type: '',
                provider: '',
                isRequired: false,
            }]);
        }

        if (schematicData?.miscellaneous?.miscList && schematicData?.miscellaneous?.miscList?.length > 0) {
            setEquipments(schematicData?.miscellaneous?.miscList?.map(equipment => ({
                ...equipment,
                isRequired: equipment.isRequired,
                equipmentName: equipment?.equipmentName,
                type: equipment.type,
                provider: equipment.provider,
                quantity: equipment.quantity
            })));
        } else miscChange();
    }, [schematicData])
    
    const miscChange = () => {

        if (!equipments || equipments.length === 0) {
            setEquipments([
                { equipmentName: 'Surface Cable length (ft)', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'Cable Clamps', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'MLE Clamps', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'MLE Guards/Protectors', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'Sand Guard', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'Desander', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'Gasguard / Gas Regulator', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'Drain valve', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'Check valve', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'Centralizer', type: '', provider: '', quantity: 0, isRequired: false },
                { equipmentName: 'CT Line', type: '', provider: '', quantity: 0, isRequired: false },
            ]);
        }
        const surfaceCable = equipments.find(equipment => equipment.equipmentName === 'Surface Cable length (ft)');
        if (surfaceCable) {
            surfaceCable.quantity = tab1Input?.hdnCable_SurfCabl || 0;
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number, colName: string) => {
        let { value } = event.target;
        if (colName === "quantity") {
            if (value === '') {
                value = '0';
            } else if (value?.startsWith('0') && value.length > 1) {
                value = value?.slice(1);
            }
        }
        const updatedEquipments = [...equipments];
        const equipment = updatedEquipments[index];

        if (colName === "isRequired") {
            equipment.isRequired = (event.target as HTMLInputElement).checked;
        } else if (colName === "type") {
            equipment.type = value;
        } else if (colName === "provider") {
            equipment.provider = value;
        } else if (colName === "quantity") {
            equipment.quantity = value;
        }

        const misc: SRMiscellaneousModel = {
            miscList: updatedEquipments?.map(equipment => ({
                ...equipment,
                isRequired: equipment.isRequired,
                equipmentName: equipment.equipmentName,
                type: equipment.type,
                provider: equipment.provider,
                quantity: equipment.quantity,
            })),
        };
        setEquipments(updatedEquipments);
        updateSchematicOtherData(misc);
        miscChange();
    }

    return (
        <Accordion
            title={LABELS?.miscellaneous}
            isOpen={miscellaneousCollapse}
            onToggle={() => handleCollapseChange(!miscellaneousCollapse)}
            content={
                <div className='gap-[16px] p-4'>
                    <div className='overflow-auto scrollable relative'>
                        <table
                            className={`min-w-full rounded-[8px] height-[100px] outline-[1px] table `}
                            style={{ zIndex: 991, maxHeight: 500, }}
                        >
                            <thead style={{ zIndex: 992 }}>
                                <tr className={` text-neutral-25`}>
                                    <th
                                        className={`px-[24px] py-[16px] text-[12px] cursor-pointer text-neutral-25`}
                                        style={{ width: "8%" }}
                                    >
                                        <div className="flex items-center">
                                            <span className={`text-[14pxpx] font-semibold`}>
                                            </span>
                                        </div>
                                    </th>
                                    <th
                                        className={`px-[24px] py-[16px] text-[12px] cursor-pointer text-neutral-25`}
                                        style={{ width: "32%" }}
                                    >
                                        <div className="flex items-center">
                                            <span className={`text-[14px] font-semibold`}>
                                                Equipment / Accessories
                                            </span>
                                        </div>
                                    </th>
                                    <th
                                        className={`px-[24px] py-[16px] text-[12px] cursor-pointer text-neutral-25`}
                                        style={{ width: "22%" }}
                                    >
                                        <div className="flex items-center">
                                            <span className={`text-[14px] font-semibold`}>
                                                Type
                                            </span>
                                        </div>
                                    </th>
                                    <th
                                        className={`px-[24px] py-[16px] text-[12px] cursor-pointer text-neutral-25`}
                                        style={{ width: "22%" }}
                                    >
                                        <div className="flex items-center">
                                            <span className={`text-[14px] font-semibold`}>
                                                Provider
                                            </span>
                                        </div>
                                    </th>
                                    <th
                                        className={`px-[24px] py-[16px] text-[12px] cursor-pointer text-neutral-25`}
                                        style={{ width: "22%" }}
                                    >
                                        <div className="flex items-center">
                                            <span className={`text-[14px] font-semibold`}>
                                                Quantity
                                            </span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    equipments?.map((item, index) => {
                                        return (
                                            <>
                                                <tr key={index}>
                                                    <td
                                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px]'
                                                        style={{ width: "8%" }}
                                                    >
                                                        <Checkbox
                                                            label=""
                                                            checked={item?.isRequired}
                                                            onChange={(e) => handleChange(e, index, "isRequired")}
                                                            name="isRequired"
                                                        />
                                                    </td>
                                                    <td
                                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px] text-left'
                                                        style={{ width: "32%" }}
                                                    >
                                                        {item?.equipmentName}
                                                    </td>
                                                    <td
                                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px] text-left'
                                                        style={{ width: "22%" }}
                                                    >
                                                        <TextShortInput
                                                            className={`flex-grow py-[12px] px-[14px] max-h-[44px] text-neutral-25 focus:outline-none bg-transparent rounded-[8px] border-[1px] border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500`}
                                                            onChange={(e) => handleChange(e, index, "type")}
                                                            value={item?.type}
                                                            type={"text"}
                                                            placeholder='Enter Here'
                                                            onBlur={miscChange}
                                                            leftAlign={true}
                                                        />
                                                    </td>
                                                    <td
                                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px] text-left'
                                                        style={{ width: "22%" }}
                                                    >
                                                        <TextShortInput
                                                            className={`flex-grow py-[12px] px-[14px] max-h-[44px] text-neutral-25 focus:outline-none bg-transparent rounded-[8px] border-[1px] border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500`}
                                                            onChange={(e) => handleChange(e, index, "provider")}
                                                            value={item?.provider}
                                                            type={"text"}
                                                            placeholder='Enter Here'
                                                            onBlur={miscChange}
                                                            leftAlign={true}
                                                        />
                                                    </td>
                                                    <td
                                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px] text-left'
                                                        style={{ width: "22%" }}
                                                    >
                                                        {
                                                            item?.equipmentName === 'Surface Cable length (ft)' ?
                                                                <div className="flex justify-left">
                                                                    {tab1Input?.hdnCable_SurfCabl || item?.quantity}
                                                                </div> :
                                                                <div className="">
                                                                    <TextShortInput
                                                                        className={`flex-grow py-[12px] px-[14px] max-h-[44px] text-neutral-25 focus:outline-none bg-transparent rounded-[8px] border-[1px] border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500`}
                                                                        onChange={(e) => handleChange(e, index, "quantity")}
                                                                        value={item?.quantity}
                                                                        type={"number"}
                                                                        placeholder='Enter Here'
                                                                        onBlur={miscChange}
                                                                        leftAlign={true}
                                                                    />
                                                                </div>
                                                        }
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>


                    {/* <TableComponent
                        data={equipments?.length > 0 ? equipments : []}
                        columns={miscellaneousColumns({
                            handleChecked: (rowIndex: number, columnIndex: number, value: number) => {
                                // miscChange(rowIndex, columnIndex, value);
                            },
                        })}
                        rowsPerPage={1}
                        overFlowClass='overflow-auto'
                    /> */}
                </div>
            }
        />
    );
}

export default Miscellaneous